<template>
    <DCard
        padding
    >
        <Form
            :adyen-settings="adyenSettings"
            :environments="environments"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/AdyenSettings/Form'

export default {
    name: 'AdyenSettingsCreate',
    components: {
        Form
    },
    props: {
        adyenSettings: {
            type: Object,
            default () {
                return {}
            }
        },
        environments: {
            type: Array,
            default () {
                return []
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.adyen-settings.store'))
        }
    }
}
</script>
